import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { isArrayEmptyOrNull } from '../../utils/ObjectUtils';
import { Component, ContextType, fireStatusUpdate, Namespace, StatusTypes } from '@chegg/commerce-utils';
var BaseCommand = /*#__PURE__*/function () {
  function BaseCommand(_ref) {
    var input = _ref.input,
      client = _ref.client,
      dispatch = _ref.dispatch,
      state = _ref.state,
      optimizelyClient = _ref.optimizelyClient;
    _classCallCheck(this, BaseCommand);
    _defineProperty(this, "input", void 0);
    _defineProperty(this, "client", void 0);
    _defineProperty(this, "dispatch", void 0);
    _defineProperty(this, "state", void 0);
    _defineProperty(this, "optimizelyClient", void 0);
    this.input = input;
    this.client = client;
    this.dispatch = dispatch;
    this.state = state;
    this.optimizelyClient = optimizelyClient;
  }
  return _createClass(BaseCommand, [{
    key: "callbackErrorsToHost",
    value:
    /**
     * Sends checkout related errors to host.
     * @errors checkout errors
     * @data optional parameter if you need to pass more data with callback
     */
    function callbackErrorsToHost(errors, command, data) {
      fireStatusUpdate([{
        status: StatusTypes.ERROR,
        command: command,
        payload: _objectSpread(_objectSpread({
          component: Component.COMMAND_MANAGER,
          context: ContextType.DROP_IN_PAYMENTS
        }, data && {
          data: data
        }), {}, {
          errors: errors
        })
      }], Namespace.DROP_IN_PAYMENTS);
    }

    /**
     * Utility function to check for the presence of errors
     * @param errors array of errors
     * @returns true if the array is defined and has at least one item
     */
  }, {
    key: "hasErrors",
    value: function hasErrors(errors) {
      return !isArrayEmptyOrNull(errors);
    }
  }]);
}();
export default BaseCommand;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/dropin-payments/dist/esm/commandManager/commands/BaseCommand.js
// module id = 216
// module chunks = 11